<template>
    <div class='parte-cima direita'>

        <section v-if='oneClient'>
	    <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/person.svg" class='img'>

                <p v-if="oneClient.name">{{ oneClient.name}}</p>
                <p v-else> --------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/card-text.svg" class='img'>
                <p v-if="oneClient != ''">{{(oneClient.cpf) ? oneClient.cpf.replace(/.*\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}.*/,"%$1") : "___.___.___-__"}}</p>
                <p v-else> --------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/geo-alt.svg" class='img'>
                <p v-if="oneClient.neighborhood">{{ oneClient.neighborhood}}</p>
                <p v-else> --------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/telephone.svg" class='img'>
                <p v-if="oneClient.phone">{{ oneClient.phone}}</p>
                <p v-else> --------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/telephone.svg" class='img'>
                <p v-if="oneClient.phone_2">{{ oneClient.phone_2}}</p>
                <p v-else> --------- </p>

            </div>
            <div class='esquerda espaco-lado-lado' >
                <img src="/imgs/icons/envelope.svg" class='img'>
                <p v-if="oneClient.email">{{ oneClient.email}}</p>
                <p v-else> --------- </p>

            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/clock.svg" class='img'>
                <p>{{ timeFormat }}</p>

            </div>
            <!-- <button class="button-cadastrar" @click="setModalCadastro()">Cadastrar</button> -->
        </section>

        <section v-else>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/person.svg" class="img">
                <p>(--) - ---- ----</p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/card-text.svg" class="img">
                <p> -------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/geo-alt.svg" class="img">
                <p> -------- </p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/telephone.svg" class="img">
                <p>(--) - ---- ----</p>
            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/telephone.svg" class="img">
                <p>(--) - ---- ----</p>

            </div>
            <div class='esquerda espaco-lado-lado'>
                <img src="/imgs/icons/envelope.svg" class="img">
                <p> -------- </p>

            </div>
            <div class='esquerda espaco-lado-lado' >
                <img src="/imgs/icons/clock.svg" class="img">
                <p>{{ timeFormat }}</p>

            </div>

            <button class="button-cadastrar" @click="setModalCadastro()">Cadastrar</button>
        </section>

    </div>
</template>

<script>
import {mapGetters,mapActions} from 'vuex'
import select2 from 'select2'
import $ from 'jquery';
import showHidden from '../../store/modules/showOrHidden'
export default {
    watch: {
        getCallTime: function() {
            this.validateCall();
        },
        time: function() {
            this.timeFormat = moment.utc(this.time * 1000).format('HH:mm:ss')
        },
        getTotalChatQueue: function(){
            if(this.getTotalChatQueue == 0) showHidden.state.showSpearhead = false;
        }
    },
    data() {
        return {
            interval:'',
            time: '',
            timeFormat: ''
        }
    },
    computed:{
        ...mapGetters(['getShowSpearhead','oneClient','getProtocol','getCallTime','getChannel', 'getTotalChatQueue']),
    },
    methods: {
        ...mapActions(["setCallTime","setModalCadastro"]),
        validateCall(){
            clearInterval(this.interval);
		    console.log("Timer aqui: ", this.getCallTime);
            var self = this;
            this.time = (this.getCallTime != 'null')? this.getCallTime : 0 ;
            if(this.getCallTime != 'null'){
                this.interval = setInterval(()=> {
                    self.time++;
                }, 1000);
            } else {
                showHidden.state.showSpearhead = false;
                clearInterval(this.interval);
            }
        }
    },
    created: function(){

        this.validateCall();

    }

}
</script>

<style scoped>
	.parte-cima{
		box-shadow: 5px 3px 6px -6px black;
		padding: 1px 5px 2px 20px;
		background-color: #ECF0F1;
	}
	.espaco-lado-lado{
		max-width: 270px;
		width: 100%;
		margin: 5px 0 5px 0;
    }
    .img{
        height: 1.7em;
    }

    .button-cadastrar{
        background-color: #27ae60;
        border-radius: 0.25em !important;
        color: white;
        border: none;
        padding: 0.4em 1em;
    }
</style>
